module.exports = __webpack_public_path__ + "img/result-paper-title.75490e61.svg";